@if (label) {
<label>{{ label }}</label>
}
<div class="content">
  <mat-form-field floatLabel="auto" appearance="outline">
    <input
      type="text"
      matInput
      [placeholder]="placeholder"
      [matAutocomplete]="autoGroup"
      displayWith="({ name }) => name"
      class="search-input"
      [(ngModel)]="query"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="disabled"
      (ngModelChange)="filterOptions($event)"
      [ngClass]="{ 'icon-right': fastDelete }"
      #input
    />
    <mat-autocomplete
      #autoGroup="matAutocomplete"
      [displayWith]="displayOptionValue"
      (optionSelected)="pickValue($event)"
    >
      <div class="infinite-scroll-ref" [class.loading]="loading" #scrollRef>
        <wm-front-infinite-scroll-container
          (scrolled)="scrolled.emit()"
          [overridedOptions]="{
            throttle: 0,
            infiniteScrollContainer: scrollRef
          }"
        >
          @for (option of filteredOptions; track trackByFn($index, option)) {
          <mat-option [value]="option">
            {{ option.label }}
          </mat-option>
          }
        </wm-front-infinite-scroll-container>

        @if (loading) {
        <mat-option disabled class="option option-spinner">
          <mat-spinner
            class="spinner-center"
            [diameter]="28"
            [strokeWidth]="3"
          ></mat-spinner>
        </mat-option>
        } @if (query?.length > 0 && options.length === 0 && !loading) {
        <mat-option disabled>
          {{ noResultLabel }}
        </mat-option>
        }
      </div>
    </mat-autocomplete>
  </mat-form-field>
  @if (fastDelete && (query || (optionSelected | async))) {
  <mat-icon
    svgIcon="close-sm"
    class="clear-input"
    [class.disabled]="disabled"
    (click)="reset()"
  ></mat-icon>
  }
</div>
